<template>
  <div id="Construction">
      <Head/>
      <div>
          <img src="../../assets/Index/c.png" alt="">
      </div>
      <RightNav/>
      <Foot/>
  </div>
</template>

<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import RightNav from "../../components/RightNav";
export default {
    components:{
        Head,
        Foot,
        RightNav
    }
}
</script>

<style lang="less" scoped>
#Construction{
    max-width: 100%;
    height: 100%;
    div{
        img{
            display: block;
            margin:.6rem auto .3rem;
            width: 5rem;
        }
    }
}

</style>